module.exports = __webpack_public_path__ + "e54d913d34c36c5d09a02386df3aa84e.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/official-icons/money-s.png
// module id = 1075
// module chunks = 0